import { response } from "app/helpers/commonInterface";
import {
  GET_ALL_TASK_REPORT_LIST_FAILURE,
  GET_ALL_TASK_REPORT_LIST_REQUEST,
  GET_ALL_TASK_REPORT_LIST_SUCCESS,
} from "../actionTypes";
import { taskData } from "./taskDataInterface";

export interface allTaskReportListState {
  loading: boolean;
  taskDetails: response<taskData[]>;
  error: string;
}

interface action {
  type: string;
  payload: any;
}

const initialState: allTaskReportListState = {
  loading: false,
  taskDetails: {},
  error: "",
};


export const getAllTaskReportListReducer = (
  state = initialState,
  action: action
) => {
  switch (action.type) {
    case GET_ALL_TASK_REPORT_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_TASK_REPORT_LIST_SUCCESS:
      return {
        loading: false,
        taskDetails: action.payload,
        error: "",
      };
    case GET_ALL_TASK_REPORT_LIST_FAILURE:
      return {
        loading: false,
        taskDetails: {},
        error: action.payload,
      };
    default:
      return state;
  }
};


